import { types } from "../types/types";
const intitalState = {
    allOurClients: []
};

const ourClientReducer = (state = intitalState, action) => {
    switch (action.type) {
        case types.OUR_CLIENTS:
            return {
                ...state,
                allOurClients: action.payload,
            };
        default:
            return { ...state };
    }
};

export default ourClientReducer;
